define('app/factories/tracker_factory',['app/setup', 'app/models/tracker'], function(takhfifan, tracker) {
  $(function($) {
    new takhfifan.Tracker();
  });
});

